import React from 'react'
import {
    changeDateFormat,
    convertDateToLocal,
    convertNumberToUSFormat,
    getShortName,
    toOrdinalSuffix,
    setBreadCrumbRoutes
} from '../../helpers/Util'
import { useNavigate } from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip'
import { toast } from 'react-toastify'
import { addMixpanelTrackingEvent } from '../../services/CommonService'
import Image from '../../common/Image'

const ListOfOrder = ({ orderStore, activeTab }) => {
    const navigate = useNavigate()

    const renderOrderImage = (imageSrc) => {
        if (imageSrc) {
            return <Image src={imageSrc} alt='design' isStatic={false} />
        } else {
            return <Image src='/images/default_product.svg' alt='design' />
        }
    }

    const renderETD = (item) => {
        return item?.deliveryDateList?.map((etd, index) => {
            return (
                <ul className='start' key={`etd_${index}`}>
                    <li>{toOrdinalSuffix(index + 1)} ETD:</li>
                    <li>
                        {changeDateFormat(etd, 'YYYY-MM-DD', 'DD MMM, YYYY')}
                    </li>
                </ul>
            )
        })
    }

    const onSetSampleDetailsBreadcrumb = (item) => {
        let newRoute = `/orders/view/${item.orderId}`
        let visitingRoutes = [
            {
                key: window.location.pathname + window.location.search || '',
                value: 'My Dashboard'
            },
            {
                key: window.location.pathname + window.location.search || '',
                value: 'Order'
            },
            {
                key: newRoute,
                value: item?.orderRefNumber
            }
        ]
        setBreadCrumbRoutes(visitingRoutes)
        navigate(newRoute)
    }

    const handleRoute = (item) => {
        onSetSampleDetailsBreadcrumb(item)
        addMixpanelTrackingEvent({}, 'BUYER_ORDER_ON_CLICK')
    }

    const renderOrderStatus = (item) => {
        if (activeTab === 'COMPLETED') {
            return <span className='delivered'>Delivered</span>
        } else if (Math.sign(item.timeLeft) === -1) {
            return <span className='overdue-time'>Overdue&nbsp;</span>
        } else {
            return <span>ETD </span>
        }
    }

    const renderOrderStatusWiseDate = (item) => {
        if (activeTab === 'COMPLETED') {
            return (
                <span className='completed-days'>
                    {item.actualDeliveryDate
                        ? changeDateFormat(
                              item.actualDeliveryDate,
                              'YYYY-MM-DD',
                              'DD-MMM'
                          )
                        : '--'}
                </span>
            )
        } else if (Math.sign(item.timeLeft) === -1) {
            return (
                <span className='overdue-days'>
                    {Math.abs(item.timeLeft) + ' Days'}
                </span>
            )
        } else {
            return (
                <span className='remaining-days'>
                    {convertDateToLocal(
                        item.deliveryDateList[0],
                        'MMM DD, YYYY'
                    )}
                </span>
            )
        }
    }

    const renderDeliveryStatus = (item) => {
        return (
            <div className='delivery-date-status flex flex-row 3xl:flex-row items-center 2xl:items-start 3xl:items-center gap-1 mb-2'>
                {renderOrderStatus(item)}
                <span className='date-info'>
                    {renderOrderStatusWiseDate(item)}
                    {/* <div className='etd-dates shadow-2dp'>
                        {renderETD(item)}
                    </div> */}
                </span>
            </div>
        )
    }

    const renderOrderList = () => {
        if (orderStore?.orderResponse?.data?.length > 0) {
            return orderStore?.orderResponse?.data?.map((item, index) => {
                return (
                    <div
                        className='single-order-card'
                        key={`order_response_${index}`}
                        onClick={() => handleRoute(item)}
                    >
                        <div className='images-half'>
                            <div className='design-images'>
                                {renderOrderImage(
                                    item.orderProductList &&
                                        item.orderProductList[0]?.image
                                )}
                                {renderOrderImage(
                                    item.orderProductList &&
                                        item.orderProductList[1]?.image
                                )}
                                {renderOrderImage(
                                    item.orderProductList &&
                                        item.orderProductList[2]?.image
                                )}
                                {renderOrderImage(
                                    item.orderProductList &&
                                        item.orderProductList[3]?.image
                                )}
                            </div>
                        </div>
                        <div className='order-details'>
                            {/*<Tooltip title={item?.name} placement={'top'} arrow>*/}
                            {/*    <span className='order-title'>*/}
                            {/*        {getShortName(item?.name, 20)}*/}
                            {/*    </span>*/}
                            {/*</Tooltip>*/}
                            {renderDeliveryStatus(item)}
                            <div className='po-numbers'>
                                <div className='pos'>
                                    <Tooltip
                                        title={item?.poNumberList?.join(',')}
                                        placement={'top'}
                                        arrow
                                    >
                                        <span className='regular-16 weight-500 black'>
                                            {getShortName(
                                                item?.poNumberList?.join(','),
                                                20
                                            )}
                                        </span>
                                    </Tooltip>
                                    {/*<span className='regular-14 gray_400'>*/}
                                    {/*    &nbsp;({item.orderRefNumber})*/}
                                    {/*</span>*/}
                                </div>
                            </div>
                            <ul className='order-quantity-details flex'>
                                <li>
                                    {item.totalStyles}&nbsp;
                                    {item.totalStyles > 1 ? 'Styles' : 'Style'}
                                </li>
                                <li>{item.orderQuantity} units</li>
                                {/*<li>${item.orderValue}</li>*/}
                            </ul>

                            <p className='regular-16 font-bold'>
                                ${convertNumberToUSFormat(item.orderValue)}
                            </p>
                            {orderStore.activeTab !== 'PENDING' &&
                                orderStore.activeTab !== 'COMPLETED' && (
                                    <div className='round-progress-68'>
                                        <div
                                            className='status pending progress'
                                            data-percentage={
                                                item?.percentageOfCompleteness
                                            }
                                        >
                                            <span className='progress-left'>
                                                <span className='progress-bar' />
                                            </span>
                                            <span className='progress-right'>
                                                <span className='progress-bar' />
                                            </span>
                                            <div className='progress-value'>
                                                <div className='task-value'>
                                                    {
                                                        item?.percentageOfCompleteness
                                                    }
                                                    %
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            {orderStore.activeTab === 'PENDING' && (
                                <div className='order-pending-state'>
                                    <div className='state-details flex align-items-center'>
                                        <div className='state-content ml-1'>
                                            {item.workflowResponseList.map(
                                                (item) =>
                                                    item?.memberResponseList && (
                                                        <>
                                                            <Image
                                                                src={
                                                                    item
                                                                        ?.memberResponseList[0]
                                                                        ?.profilePicDocument
                                                                        ?.docUrl
                                                                }
                                                                alt='profile'
                                                                isStatic={false}
                                                            />
                                                            <span className='state-title regular-14 gray_400 mb--1'>
                                                                {item.stepName}
                                                            </span>
                                                        </>
                                                    )
                                            )}
                                            <div className='four-states'>
                                                {item.workflowResponseList.map(
                                                    (step) => (
                                                        <span
                                                            key={
                                                                step.workflowStep
                                                            }
                                                            className={`${
                                                                step.status ===
                                                                'COMPLETED'
                                                                    ? 'complete-state'
                                                                    : step.status ===
                                                                          'PENDING' &&
                                                                      step?.memberResponseList
                                                                    ? 'pending-state'
                                                                    : ''
                                                            }`}
                                                        />
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )
            })
        }
    }

    return <div className='order-card-items'>{renderOrderList()}</div>
}

export default ListOfOrder
